export const clearForm = (formElement, ignoreAttribute) => {
    var elements = formElement.elements;

    // formElement.reset();

    for (var i = 0; i < elements.length; i++) {
        var field_type = elements[i].type.toLowerCase();
        var field_ignore = elements[i].getAttribute(ignoreAttribute);

        if (!field_ignore) {
            switch (field_type) {
                case "text":
                case "password":
                case "textarea":
                case "hidden":
                    elements[i].value = "";
                    break;

                case "radio":
                case "checkbox":
                    if (elements[i].checked) {
                        elements[i].checked = false;
                    }
                    break;

                case "select-one":
                case "select-multi":
                    elements[i].selectedIndex = -1;
                    break;

                default:
                    break;
            }
        }
    }
};

export default clearForm;
